export default {
  zh: {
    resetPassword: '重置密码',
    email: '邮箱',
    setPassword: '输入新密码',
    confirmPwd: '确认密码',
    submit: '确认',
    networkError: '网络错误，请稍后再试'
  },
  en: {
    resetPassword: 'Reset Password',
    email: 'Email',
    setPassword: 'New Password',
    confirmPwd: 'Reenter Password',
    submit: 'Submit',
    networkError: 'Network error, please try again later'
  }
}



// WEBPACK FOOTER //
// ./src/views/resetPassword/lang.js